import React, { memo, useCallback } from 'react';
import AutoGrowingTextarea from '../AutoGrowingTextarea';
import { GptImage2Params } from '#types/types';
import { useKernel } from '@/kernel/Kernel';

interface GptImage2ControlPanelProps {
  params: GptImage2Params;
  setModelParams: (
    updater: (
      prevParams: { [model: string]: GptImage2Params }
    ) => { [model: string]: GptImage2Params }
  ) => void;
  diffusionModel: string;
}


export const getDefaultGptImage2Params = (): GptImage2Params => ({
  prompt: '',
  seed: -1,
});

const GptImage2ControlPanel: React.FC<GptImage2ControlPanelProps> = ({
  params,
  setModelParams,
  diffusionModel,
}) => {
  const { kernel } = useKernel();

  const updateParam = useCallback((
    name: keyof GptImage2Params,
    value: GptImage2Params[keyof GptImage2Params],
  ) => {
    setModelParams((prevModelParams) => {
      const currentParams = prevModelParams[diffusionModel];
      if (!currentParams) {
        console.error(`[GptImage2ControlPanel] Missing params for model "${diffusionModel}".`);
        return prevModelParams;
      }
      return {
        ...prevModelParams,
        [diffusionModel]: {
          ...currentParams,
          [name]: value,
        },
      };
    });

    kernel.current?.logUserAction('Setting Changed', {
      setting_name: name,
      value: name === 'prompt' ? undefined : value,
      value_length: name === 'prompt' ? String(value || '').length : undefined,
      model_name: diffusionModel,
      source_component: 'GptImage2ControlPanel',
    });
  }, [diffusionModel, setModelParams, kernel]);

  const handlePromptChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    updateParam('prompt', e.target.value);
  }, [updateParam]);

  return (
    <>
      <div className="mb-4">
        <AutoGrowingTextarea
          label="Prompt"
          placeholder="Describe the image edit to apply..."
          description="Main editing instruction."
          name="prompt"
          value={params.prompt}
          onChange={handlePromptChange}
          onEnterPress={kernel.current?.triggerGenerate}
          maxHeight={600}
          labelClassName="block text-lg font-semibold text-white mb-2"
        />
      </div>
    </>
  );
};

export default memo(GptImage2ControlPanel);
